<div class="grid-container padding-y-4">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <legend class="usa-legend usa-legend--large">TSP Rate Participation</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @if (disableButtons) {
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine" id="frtInitialGrid"
        style="height: 200;"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [gridOptions]="frtInitialGridOptions"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [suppressDragLeaveHidesColumns]="true"
        (selectionChanged)="onSelectionChanged($event)"
        ag-grid-resize>
      </ag-grid-angular>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ul class="usa-button-group">
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" [disabled]="disableAccept || disableButtons" (click)="acceptRejectTspParticipation(true)">Accept</button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="goToDuns()" [disabled]="!disableAccept || enableContinue || disableButtons">Continue</button>
        </li>
      </ul>
    </div>
  </div>
</div>
